export default __webpack_public_path__ + "menu-product-smop-icon.8bb14b433c2cd09d640c41902b921eed.svg";